/**
 * Pantalla de **Horario semanal** (`/horario`). Reemplaza el `PlaceholderPage` de
 * `ROUTES.schedule`. Equivale a `schedule.html` del SSR (demolido en esta feature).
 *
 * Exige `schedule` (mismo permiso que el menú del SSR y la página) vía la vista
 * compartida `ScheduleView`, en modo NO láser (rejilla de órdenes normales,
 * excluyendo láser y anuladas). La visibilidad de la entrada del menú la gobierna
 * `navConfig.ts` (operario en "Operación"; el resto en "Horarios"); aquí solo se
 * sirve la pantalla.
 */
import { SCHEDULE_PERMISSION } from "../constants";
import { ScheduleView } from "./ScheduleView";

export function ScheduleScreen() {
  return (
    <ScheduleView title="Horario semanal" permission={SCHEDULE_PERMISSION} laser={false} />
  );
}
